import { Injectable } from '@angular/core';
import { SchoolNaam } from './schooldropdown';
import { SchoolBestuur} from './schoolbestuurdropdown';



@Injectable()
export class SchoolDropdownService {

  getSchoolBestuur(){

    return [
      new SchoolBestuur('DOS', 'DOS'),
      new SchoolBestuur('RKCS', 'RKCS'),
      new SchoolBestuur('VPCO', 'VPCO'),
      new SchoolBestuur('SOZDA', 'SOZDA'),
      new SchoolBestuur('EBG', 'EBG'),
      new SchoolBestuur('SCONS', 'SCONS'),
      new SchoolBestuur('FSHP', 'FSHP'),
      new SchoolBestuur('PIPB', 'PIPB'),
      new SchoolBestuur('SNS', 'SNS'),
      new SchoolBestuur('KCB', 'KCB'),
      new SchoolBestuur('COM', 'COM'),
      new SchoolBestuur('MBCB', 'MBCB'),
      new SchoolBestuur('RAK', 'RAK'),
      new SchoolBestuur('DEM', 'DEM'),
      new SchoolBestuur('ESB', 'ESB')


    ]
  }

  getSchoolNamen() {
    return [
     new SchoolNaam( '01','1 Oranjeschool','DOS' ),
     new SchoolNaam( '02','2 Angela Jessurun Simon','DOS' ),
     new SchoolNaam( '03','3 Prins Bernhardschool','DOS' ),
     new SchoolNaam( '04','4 Skol Basiko Elis Juliana','DOS' ),
     new SchoolNaam( '05','5 Prinses Margrietschool','DOS' ),
     new SchoolNaam( '06','6 Johan van Walbeeckschool','DOS' ),
     new SchoolNaam( '07','7 C.J. Krijtschool','DOS' ),
     new SchoolNaam( '08','8 Joan Mauritsschool','DOS' ),
     new SchoolNaam( '09','9 A. E. Goiloschool','DOS' ),
     new SchoolNaam( '10','10 C.M.L. Maduroschool','DOS' ),
     new SchoolNaam( '11','11 P.L. Brionschool','DOS' ),
     new SchoolNaam( '12','12 J.W.Th. Schotborghschool','DOS' ),
     new SchoolNaam( '13','13 M.M. Römerschool','DOS' ),
     new SchoolNaam( '14','14 Skol Básiko Cola Debrot','DOS' ),
     new SchoolNaam( '15','15 Skol Myrna Dovale','DOS' ),
     new SchoolNaam( '16','16 Skol dr. Nelly Winkel','DOS' ),
     new SchoolNaam( '17','17 G.O.G.','RKCS' ),
     new SchoolNaam( '18','18 Kolegio Annie Koenraad','RKCS' ),
     new SchoolNaam( '19','19 Kolegio San Dominico','RKCS' ),
     new SchoolNaam( '20','20 Kolegio Don Sarto','RKCS' ),
     new SchoolNaam( '21','21 Mgr. Niewindt College','RKCS' ),
     new SchoolNaam( '22','22 St. Albertus College','RKCS' ),
     new SchoolNaam( '23','23 St. Franciscus College','RKCS' ),
     new SchoolNaam( '24','24 St. Antonius College','RKCS' ),
     new SchoolNaam( '25','25 Kolegio San Martinus de Porres','RKCS' ),
     new SchoolNaam( '26','26 St. Paulus College','RKCS' ),
     new SchoolNaam( '27','27 St. Joris College','RKCS' ),
     new SchoolNaam( '28','28 Glorieux College','RKCS' ),
     new SchoolNaam( '29','29 Kolegio Santa Clara','RKCS' ),
     new SchoolNaam( '30','30 Kolegio San Hose','RKCS' ),
     new SchoolNaam( '31','31 Kolegio Mgr. Willem Ellis','RKCS' ),
     new SchoolNaam( '32','32 Kolegio Chaya Willems','RKCS' ),
     new SchoolNaam( '33','33 Kolegio Bellefaas Martis','RKCS' ),
     new SchoolNaam( '34','34 Kolegio Dodo Palm','RKCS' ),
     new SchoolNaam( '35','35 St. Margaretha College','RKCS' ),
     new SchoolNaam( '36','36 Sta. Rosa de Lima College','RKCS' ),
     new SchoolNaam( '37','37 Kolegio Iris Bruyning','RKCS' ),
     new SchoolNaam( '38','38 Kolegio Maria Auxiliadora','RKCS' ),
     new SchoolNaam( '39','39 Kolegio Nechi Pieters','RKCS' ),
     new SchoolNaam( '40','40 Berg Carmel College','RKCS' ),
     new SchoolNaam( '41','41 Coromoto College','RKCS' ),
     new SchoolNaam( '42','42 Fatima  College','RKCS' ),
     new SchoolNaam( '43','43 Kolegio Vigdis Jonckheer-Mensing' ,'RKCS'),
     new SchoolNaam( '44','44 Kolegio Santa Famia','RKCS' ),
     new SchoolNaam( '45','45 Kennedy LOM school','RKCS' ),
     new SchoolNaam( '46','46 Marnixschool','VPCO' ),
     new SchoolNaam( '47','47 Dr. Albert Schweitzerschool','VPCO' ),
     new SchoolNaam( '48','48 Dividivi LOM school','VPCO' ),
     new SchoolNaam( '49','49 Adventschool Mahuma Zuid','SOZDA' ),
     new SchoolNaam( '50','50 Adventschool Koraal Specht','SOZDA' ),
     new SchoolNaam( '51','51 Adventschool Bonam','SOZDA' ),
     new SchoolNaam( '52','52 Emmy Berthold school','EBG' ),
     new SchoolNaam( '53','53 Skol Básiko Immanuel','SCONS' ),
     new SchoolNaam( '54','54 Kolegio Erasmo','FSHP' ),
     new SchoolNaam( '55','55 Pipita Basisschool','PIPB' ),
     new SchoolNaam( '56','56 H.J.A. Schroederschool','SNS' ),
     new SchoolNaam( '57','57 Klein College','KCB' ),
     new SchoolNaam( '58','58 College Op Maat','COM' ),
     new SchoolNaam( '59','59 De Meander','DEM' ),
     new SchoolNaam( '71','71 Muchanan Balente College','MBCB' ),
     new SchoolNaam( '72','72 Privéschool de Rakkers','RAK' ),
     new SchoolNaam( '73','73 Skol M.C. Piar','DOS' ),
     new SchoolNaam( '74','74 Skol Marieta Alberto ZMLK/MLK','DOS' ),
     new SchoolNaam( '75','75 Prof. Dr. I.C. van Houteschool','DOS' ),
     new SchoolNaam( '76','76 Ala Blancaschool','RKCS' ),
     new SchoolNaam( '77','77 Blenchischool','RKCS' ),
     new SchoolNaam( '78','78 Br. Rigobertusschool','RKCS' ),
     new SchoolNaam( '79','79 Fr. Evoniusschool','RKCS' ),
     new SchoolNaam( '80','80 Kolegio Sur Herman Joseph','RKCS' ),
     new SchoolNaam( '81','81 Soeur Hedwigschool','RKCS' ),
     new SchoolNaam( '99','99 Kolegio Siña Duru','ESB' )
    
    ];
  }
  
  



}